<template>
    <b-card no-body>
        <DetailCommissionModal :detail_commission.sync="modals.detail_commission" v-on:closeModal="closeModal()" :commission_item="commission_item" :is_show_detail="is_show_detail" />
        <!-- HEADER -->
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>

        <!-- SEARCH INPUT -->
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                    label="Search"
                    v-model="searchQuery"
                    v-on:input="debouncedHandler"
                    prepend-icon="fas fa-search"
                    placeholder="Search..."
                    >
                    </base-input>
                </b-col>
            </b-row>
        </b-col>

         <!-- TABLE LIST -->
        <div class="table-listings">
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"

                :data="queriedData"
                style="width: 100%;"
                @selection-change="selectionChange"
            >
    
                <el-table-column
                    prop="cset_label"
                    label="Title"
                    sortable
                >
                    <template slot-scope="scope">
                        <p class="top-line">
                            {{ scope.row.cset_label }}
                        </p>
                    </template>
                </el-table-column>
    
                <!-- <el-table-column
                    prop="cset_code"
                    label="commission code"
                    sortable
                >
                    <template slot-scope="scope">
                        <p class="top-line">
                            {{ scope.row.cset_code }}
                        </p>
                    </template>
                </el-table-column> -->

                <el-table-column
                    width="50"
                >
                    <template slot-scope="scope">
                        <div class="text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg"  @click="detailCommission(scope.row)" class="cursor-pointer" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-40-176h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24m40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64"/></svg>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    width="50"
                >
                    <template slot-scope="scope">
                        <div class="text-warning">
                            <svg xmlns="http://www.w3.org/2000/svg" @click="editCommission(scope.row)" class="cursor-pointer" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0l-30.1 30 97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5l167.3-167.4-98-98zM96 64c-53 0-96 43-96 96v256c0 53 43 96 96 96h256c53 0 96-43 96-96v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32z"/></svg>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- FOOTER -->
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>
    </b-card>
</template>
<script>
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import mainEventBus from '@/assets/js/mainEventBus'
import { mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import UpdateRoleAccessModal from '@/views/Configurations/RoleAccessSettings/RoleAccessModals/UpdateRoleAccessModal'
import DetailCommissionModal from '@/views/Configurations/CommissionSettings/CommissionModals/DetailCommissionModal'

import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'

export default {
    mixins: [notifyFunctionMixin,clientPaginationMixin],
    components: {
        BasePagination,
        UpdateRoleAccessModal,
        DetailCommissionModal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
    },
		props: {
			available_group_access: Array
		},
    data() {
        return {
            modals: {
                update_commission: false,
                detail_commission: false,
            },
            isTableLoading: true,
            propsToSearch:['cset_label'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [],
            commission_item: {},
            pagination:{
                perPageOptions: [5, 10, 25, 50, 100, 500]
            },
            is_show_detail: false,
        }
    },
    created(){
        this.getCommission()
    },  
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);

        mainEventBus.$on('refresh-commission', this.getCommission)
    },
    beforeUnmount() {
        mainEventBus.$off('refresh-commission', this.getCommission)
    },
		computed:{
      ...mapState(useAuthStore, ['auth_user'])
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
        getCommission(){
            this.isTableLoading = true
            axios.get(services.commission + '/commission-settings', {headers: getHeader()})
            .then(res => {
                this.tableData = res.data
                console.log(res.data);
                this.isTableLoading = false
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        editCommission(item){
            this.is_show_detail = false
            this.commission_item = item
            this.modals.detail_commission = true;
        },
        detailCommission(item){
            this.is_show_detail = true
            this.commission_item = item
            this.modals.detail_commission = true;
        },
        deleteCommission(role_id){
            swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(services.access_control + 'role/' + role_id, {headers: getHeader()})
                    .then(res => {
                        this.getCommission();
                        this.notifySuccess('<b>Role Access: </b> - Successfully Deleted.')
                        return 
                    })
                    .catch(e => {
                        this.isTableLoading = false
                        this.errorFunction(e)
                    })
                }
            })
        },
        closeModal(){
            this.getCommission();
            this.modals.update_commission = false;
            this.modals.detail_commission = false;
        },
    }
}
</script>